import { Injectable } from '@angular/core';

import { FocusableMixin } from './focusable.model';

@Injectable({
  providedIn: 'root',
})
export class FormFocusableService {
  isFocusable(instance: unknown): instance is FocusableMixin {
    return (
      typeof instance === 'object' &&
      instance !== null &&
      typeof (instance as FocusableMixin).setFocus === 'function'
    );
  }
}
